import { RECIPE_ENDPOINTS } from "./endpoints";
import type { Recipe } from "./types";
import { apiRequestWithData } from "../shared";

export default async function getRecipeDetails(recipeId: number | string): Promise<Recipe> {
  const numericId = typeof recipeId === "string" ? parseInt(recipeId, 10) : recipeId;
  return apiRequestWithData<Recipe>(RECIPE_ENDPOINTS.GET_BY_ID(numericId));
}
